import axios from "axios";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;

// withCredentials=true → browser sends the httpOnly `access_token` cookie set by backend
// on every /api/* request. This is the primary auth channel for browser sessions.
const api = axios.create({
  baseURL: `${BACKEND_URL}/api`,
  withCredentials: true,
});

export default api;

export function formatError(e) {
  const d = e?.response?.data?.detail;
  if (!d) return e?.message || "Something went wrong";
  if (typeof d === "string") return d;
  if (Array.isArray(d)) return d.map((x) => x.msg || JSON.stringify(x)).join(" ");
  return String(d);
}
